
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '~/store/modules/user';

@Component
export default class UserIdentifiers extends Vue {
    get userMail() {
        return UserModule.userMail;
    }
    get userId() {
        return UserModule.id;
    }
}
